
  import { css } from 'lit';
  export const styles = css`[part~=base]{border-radius:var(--border-radius);color:var(--text-color);background:var(--background);box-shadow:var(--elevation)}igc-button::part(base),igc-button::part(base):hover{color:var(--button-color);background:rgba(0,0,0,0)}`;
  